/**
 * @generated SignedSource<<59554e5c48b23248e96fbd4f6208bc53>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type preloadMentionsUsersUsersQuery$variables = {
  ids: ReadonlyArray<string>;
};
export type preloadMentionsUsersUsersQuery$data = {
  readonly users: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }> | null | undefined;
};
export type preloadMentionsUsersUsersQuery = {
  response: preloadMentionsUsersUsersQuery$data;
  variables: preloadMentionsUsersUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "ids"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadMentionsUsersUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadMentionsUsersUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
    "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
    "metadata": {},
    "name": "preloadMentionsUsersUsersQuery",
    "operationKind": "query",
    "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
  }
};
})();

(node as any).hash = "3783fdf735e372b90adc93c9f8ad8005";

export default node;
